import React, { useState } from 'react';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      if (username === 'optimus' && password === 'Prime2026!#') {
        onLogin();
      } else {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 400);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <svg width="60" height="48" viewBox="0 0 25 20" fill="none" style={{ color: '#1a2e58' }}>
            <path fill="currentColor" fillRule="evenodd" d="M5.638 5.952c.96-.196 1.566-.728 1.743-1.357.192-.686.753-1.19 1.566-1.413.798-.21 1.758-.112 2.644.237.813.322 1.714.392 2.393.126.902-.363 1.108-1.245.517-2.084-.738-1.05-2.393-1.665-3.619-1.4-.65.155-1.063.518-1.167.994-.118.56-.665.993-1.433 1.19l-.059.013c-.783.196-1.758.126-2.615-.224-.738-.307-1.61-.405-2.393-.237C1.68 2.147 1 3.46 1.96 4.707c.768.979 2.348 1.51 3.678 1.245M19.45 10.19c-.812.238-1.255.853-1.27 1.609-.03.867-.488 1.609-1.315 1.986l-.06.029c-.856.391-1.964.35-3.042-.085-.975-.391-2.068-.405-2.955.085-1.211.671-1.699 2.238-.975 3.749.975 2.043 3.472 3.008 5.215 2.084.872-.475 1.33-1.315 1.36-2.252.029-1.05.575-1.86 1.432-2.266.827-.406 1.89-.406 2.925.042.901.391 1.832.433 2.526.07 1.285-.686 1.123-2.49-.236-3.848-1.034-.993-2.541-1.51-3.605-1.203m-1.654-6.38c-.768.154-1.182.658-1.182 1.287 0 .56-.296 1.022-.916 1.232l-.162.055c-.621.21-1.448.14-2.202-.21-.797-.363-1.713-.475-2.481-.237-.783.238-1.256.797-1.36 1.469-.088.657-.576 1.203-1.344 1.455l-.207.07c-.782.266-1.713.154-2.555-.224-.96-.434-2.142-.518-3.176-.098C.88 9.156.157 10.499.66 11.828c.694 1.819 3.072 2.728 4.963 1.987 1.005-.392 1.61-1.162 1.743-2.015.118-.784.665-1.4 1.448-1.693l.103-.042c.769-.28 1.714-.21 2.556.196.886.42 1.906.518 2.718.196.798-.308 1.197-.938 1.197-1.665 0-.658.37-1.175 1.004-1.4l.074-.027c.62-.224 1.433-.14 2.201.21.813.363 1.684.475 2.334.21 1.152-.448 1.123-1.805-.059-2.897-.857-.811-2.186-1.259-3.146-1.077" clipRule="evenodd"/>
          </svg>
          <h1 className="login-title">Engineering Lab</h1>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button
            type="submit"
            className="login-btn"
            disabled={loading || !username || !password}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
